import { useContext } from 'react';
import { FilterContext } from 'providers/Filter';
import { IFilterOptions } from 'interfaces/SelectOptions';

export const useSelectFilter = (name: string) => {
  const { filter } = useContext(FilterContext);

  if (!filter) {
    throw new Error(`useSelectFilter must be used within a FilterProvider`);
  }

  if (filter[name]) return filter[name];
  return [];
};

export const useDispatchFilter = () => {
  const { onChange } = useContext(FilterContext);

  if (!onChange) {
    throw new Error(`useDispatchFilter must be used within a FilterProvider`);
  }

  return (name: string, value: IFilterOptions[]) => {
    onChange({ [name]: value });
  };
};

export const useClearFilter = () => {
  const { onClear } = useContext(FilterContext);

  if (!onClear) {
    throw new Error(`useClearFilter must be used within a FilterProvider`);
  }

  return onClear;
};
